import { chipClasses } from '@mui/material/Chip';
import { createComponentOverrides } from '../theme/create-component-overrides';
export var createMuiChipOverrides = createComponentOverrides(function (_a) {
    var _b, _c;
    var mixins = _a.mixins, palette = _a.palette, spacing = _a.spacing, tokens = _a.tokens;
    return ({
        defaultProps: {
            variant: 'outlined',
        },
        styleOverrides: {
            root: (_b = {
                    color: tokens.color_fg_bold,
                    height: 'unset',
                    borderColor: tokens.color_border_bold,
                    borderRadius: 4
                },
                _b["&.".concat(chipClasses.disabled)] = {
                    opacity: 1,
                    color: palette.action.disabled,
                    backgroundColor: palette.action.disabledBackground,
                },
                _b['&:hover'] = {
                    cursor: 'pointer',
                    boxShadow: 'none',
                    backgroundColor: palette.action.hoverBackground,
                },
                _b),
            label: {
                paddingTop: spacing(1.25),
                paddingBottom: spacing(1.25),
                paddingLeft: spacing(1),
            },
            sizeSmall: {
                height: 'unset',
            },
            labelSmall: {
                padding: spacing(0.5, 1),
            },
            outlined: (_c = {},
                _c[".".concat(chipClasses.clickable, "&:focus, .").concat(chipClasses.deletable, "&:focus")] = {
                    backgroundColor: 'transparent',
                },
                _c[".".concat(chipClasses.clickable, "&:hover, .").concat(chipClasses.deletable, "&:hover")] = {
                    backgroundColor: palette.action.hoverBackground,
                },
                _c),
            deletable: {
                '&:hover': {
                    backgroundColor: palette.action.hoverBackground,
                },
                '&:focus': mixins.focusRing(),
            },
            clickable: {
                '&:hover': {
                    backgroundColor: palette.action.hoverBackground,
                },
                '&:focus': mixins.focusRing(),
            },
            deleteIcon: {
                height: '1rem',
                width: '1rem',
                color: tokens.color_fg_default,
            },
        },
    });
});
